export default {
  delistListPage: {  //预退批次--分页查询
    url: '/ec-pc-api/cycle/delist/listPage',
    type: 'post'
  },
  addDelistBatch: {  //预退批次--新增
    url: '/ec-pc-api/cycle/delist/addDelistBatch',
    type: 'post'
  },
  newProductOverview: {  //产品数量分布
    url: '/ec-pc-api/cycle/delist/newProduct/overview',
    type: 'get'
  },
  distributed: {  //产品数量分布
    url: '/ec-pc-api/cycle/delist/proNum/distributed',
    type: 'get'
  },
  categorySaleTop: {  //品类销量top5
    url: '/ec-pc-api/cycle/delist/categorySaleTop',
    type: 'get'
  },
  saleMsgProportion: {  //销量-销售额同比去年
    url: '/ec-pc-api/cycle/delist/saleMsg/proportion',
    type: 'get'
  },
  
  updateOpinionRemark: {  //电商预退产品清单-意见备注更新
    url: '/ec-pc-api/cycle/delist/updateOpinionRemark',
    type: 'post'
  },
  queryConfirmLog: {  //电商预退产品清单-查询清单日志
    url: '/ec-pc-api/cycle/delist/queryConfirmLog',
    type: 'post'
  },
  categoryOptions: {  //各流程产品分页品类下拉
    url: '/ec-pc-api/cycle/delist/process/categoryOptions',
    type: 'post'
  },
  queryProcessStatus: {  //查询批次节点及状态
    url: '/ec-pc-api/cycle/delist/queryProcessStatus',
    type: 'get'
  },
  suitDel: {  //套件tab页-删除
    url: '/ec-pc-api/cycle/delist/suit/del',
    type: 'post'
  },
  delistPublish: {  //流程发布
    url: '/ec-pc-api/cycle/delist/publish',
    type: 'post'
  },
  columnsv3: {  //查询自定义列头-携带参数
    url: '/ec-pc-api/customize/columns/v3',
    type: 'post'
  },
  publishStatus: {  //发布按钮状态
    url: '/ec-pc-api/cycle/delist/publish/status',
    type: 'post'
  },
  suitProductList: {  //套件tab页-产品数据弹窗
    url: '/ec-pc-api/cycle/delist/suit/productList',
    type: 'post'
  },
  productBaseInfo: {  //产品基础数据弹窗
    url: '/ec-pc-api/cycle/delist/product/baseInfo',
    type: 'get'
  },
  queryDelistAnalyseCategory: {  //查询预退分析表品类下拉选项
    url: '/ec-pc-api/cycle/delist/queryDelistAnalyseCategory',
    type: 'get'
  },
  soldProducts: {  //各月销量走势
    url: '/ec-pc-api/cycle/delist/soldProducts',
    type: 'post'
  },
  monthSaleChart: {  //新品月均销量分布
    url: '/ec-pc-api/cycle/delist/monthSaleChart',
    type: 'post'
  },
  completeInfoSearch: {  //全网清仓完成进度动态分页
    url: '/ec-pc-api/clearStock/manage/all/goods/completeInfo/search',
    type: 'post'
  },
  
  
}